module.exports = __webpack_public_path__ + "static/media/grid_cell.7b7a13f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/grid_cell.svg
// module id = 1400
// module chunks = 0